// extracted by mini-css-extract-plugin
export default {"animate":"zoomInZoomOut_animate__KIhlh","zoom-in-zoom-out":"zoomInZoomOut_zoom-in-zoom-out__SNgKo"};